<template>
</template>

<script>

  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'Verify',
    data() {
      return {

      };
    },
    components: {

    },
    computed: {
      getToken() {
        return this.$route.params.token
      },
      getEmail() {
        return this.$route.params.email
      },
      getClient() {
        return this.$store.state.client
      },
      getHistoryPage() {
        return this.$store.state.historyPage
      }
    },
    methods: {

    },
    created() {
      let self = this;
      // Component accessed when going on route: base_url/token/{token}
      // We are taking the token and logging users in, and after that, redirecting to homepage
      if (this.$route.params.token) {
        if (this.$route.params.token == 'invalid') {
          setTimeout(function() {
            self.$router.push({name: 'login', params: {error: true}})
          }, 300)
        } else {
          piincHttp.get('email/verify/' + this.getToken + '/' + this.getEmail, {
            email: this.getEmail,
            token: this.getToken
          }).then(function(response) {
            localStorage.setItem('token', response.data.token);
            piincHttp.defaults.headers.common['Authorization'] = response.data.token;
            setTimeout(function() {
              piincHttp.get('users/me', {
                headers: {
                  'Authorization': 'Bearer ' + response.data.token
                }
              }).then(function(response) {
                let selectedClient = {}

                selectedClient = response.data.clients[0]

                window.location.href = '/client/' + selectedClient.slug + '?tabindex=1';

              }, function() {

              });

            }, 500)
          }, function(error) {
            self.$router.push({name: 'login', params: {expired: true}})
          })


        }
      }
    }
  }

</script>
